import styles from './index.module.less'
import { Dispatch, MutableRefObject, SetStateAction, useEffect, useState } from 'react'
import { useRequest } from 'ahooks'
import { IResAccountRewards } from '@/api/account/interface'
import { getAccountRewards } from '@/api/account'
import MeEmpty from '@/components/MeEmpty'
import ShareCard from '../shareCard/index'
import LoadingCom from '@/components/LoadingCom'

interface IProps {
  address: string
  pageParams: {
    offset: number
    limit: number
  }
  setTotal: (total: number) => void
  setLoading: (loading: boolean) => void
  nextKey: MutableRefObject<string>
  setNextKeyData: Dispatch<SetStateAction<string>>
  keyArray: MutableRefObject<{
    [key: number]: string
  }>
  currentGroupIndex: MutableRefObject<number>
  groupSize: MutableRefObject<number>
}
const ShareCardList = ({
  address,
  pageParams,
  setTotal,
  setLoading,
  nextKey,
  setNextKeyData,
  keyArray,
  currentGroupIndex,
  groupSize,
}: IProps) => {
  const listParams = {
    address,
    limit: pageParams.limit,
    offset: pageParams.offset,
  }

  /** 参数组装 */
  const getPageParams = () => {
    const params: any = {
      offset: pageParams.offset,
      limit: pageParams.limit,
      address,
    }
    if (keyArray.current[currentGroupIndex.current]) {
      params.key = keyArray.current[currentGroupIndex.current]
    }

    return params
  }

  const [shareList, setShareList] = useState<IResAccountRewards[]>([])
  const { loading, run } = useRequest(() => getAccountRewards(getPageParams()), {
    manual: true,
    onSuccess: (res) => {
      setShareList(res?.kyc_invite_transaction || [])
      if (res?.group_count) {
        setTotal(Number(res?.group_count))
      } else {
        setTotal(0)
      }
      nextKey.current = res.next_key || ''
      setNextKeyData(res.next_key || '')
      if (currentGroupIndex.current === 0 && res.next_key) {
        groupSize.current = Number(res.group_count)
      }
    },
  })

  useEffect(() => {
    run()
  }, [pageParams, run, address, currentGroupIndex])

  useEffect(() => {
    setLoading(loading)
  }, [loading, setLoading])

  return (
    <div className={styles.wrap}>
      {loading && <LoadingCom />}
      {!loading && shareList.length === 0 && <MeEmpty />}
      {shareList.map((item) => (
        <ShareCard
          key={`shardCardList${item.tx_hash}${item.account}`}
          {...item}
          address={item.account}
        />
      ))}
    </div>
  )
}

export default ShareCardList
